import type { ReactNode } from 'react';

/**
 * Shared shell for the static informational pages — Privacy Policy,
 * Terms of Service, Safety Center, Community Guidelines. Keeps every
 * legal/safety surface visually consistent and routes the user back
 * to Home with one tap when they're done reading.
 *
 * `lastUpdated` is rendered as a small editorial line near the top so
 * a reader can immediately see how fresh the text is. Pass a real
 * ISO-style date string; the page does no other re-formatting.
 *
 * Uses a plain `<a href="/">` for the back link — these pages render
 * outside the BrowserRouter in App.tsx (they're public + reachable
 * from any session state), so the react-router <Link> would throw on
 * mount. A hard navigation back to root is the correct semantic too:
 * we want a fresh app boot when the user returns from reading legal.
 */
export function LegalPage({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <main className="legal">
      <div className="legal-inner">
        <a href="/" className="back-link">
          ← Home
        </a>
        <h1>{title}</h1>
        <p className="muted legal-meta">Last updated {lastUpdated}</p>
        {children}
        <p className="muted legal-footer-note">
          Have a question about anything on this page? Email{' '}
          <a href="mailto:hello@lessalone.app">hello@lessalone.app</a>.
        </p>
      </div>
    </main>
  );
}
